<div
    appAccordionDirective
    [id]="id"
    [expanded]="expanded"
    [adjustVelocity]="adjustVelocity"
    (expandChange)="expandChange.emit($event)"
>
    <button
        type="button"
        class="{{ accordionClasses.Button }}"
        [ngClass]="{ 'active': expanded, 'menu-type': type === 'menu', 'group-type': type === 'group' }"
    >
        <ng-container *ngIf="type === 'menu'">
            <span class="svg-wrapper">
                <app-svg-icon iconName="chevron_down"></app-svg-icon>
            </span>
        </ng-container>
        <ng-content select="[slot=header]"></ng-content>
        <ng-container *ngIf="type === 'regular' || type === 'group'">
            <span class="svg-wrapper right">
                <app-svg-icon iconName="chevron_down"></app-svg-icon>
            </span>
        </ng-container>
    </button>
    <div
        [ngStyle]="contentWrapperStyle"
        class="{{ accordionClasses.Content }}"
        [ngClass]="{ 'content': true, 'indented': type === 'menu', 'group-type': type === 'group' }"
    >
        <ng-content select="[slot=content]"></ng-content>
    </div>
</div>
